const RiverHeader = {
  toggler: null,
  header: null,
  selected: null,
  featured: null,
  drop: null,
  alert: null,
  selectedMenu: null,
  selectedItem: null,

  initMenu() {
    this.toggler = document.querySelector(".menu-toggler")
    this.drop = document.querySelector(".drop")
    this.alert = document.querySelector(".alert")
    this.header = document.querySelector("#main-header")
    this.selected = document.querySelector("#selected-item")
    this.featured = document.querySelector("#featured-item")
    this.selectedMenu = document.querySelector("#tablet-sub-menu")
    this.items = document.querySelectorAll(".menu-item")
    this.parents = document.querySelectorAll(".menu-item-parent")

    this.initToggle()
    this.initHovers()
    this.initParents()
  },

  initToggle() {
    if(!this.toggler){
      return
    }

    this.toggler.addEventListener("click", (e) => {
      e.preventDefault()

      this.toggleClasses(this.drop, ["-translate-y-16", "top-full", "opacity-100", "z-20"])
      this.toggleClasses(this.drop, ["-z-10", "bottom-96"])
      this.toggleClasses(this.header, ["is-opened"])
      this.toggleClasses(this.toggler, ["is-active"])
    })
  },

  initParents() {
    ;[...this.parents].forEach((parent, index) => {
      parent.addEventListener("click", (e) => {
        this.toggleItem(e, index)
      })
    })
  },

  toggleItem(e, ind) {
    // currentTarget is the link itself, e.target can be text wrapped by Google Translate in <font> tags
    let subMenu = e.currentTarget.parentElement.parentElement.querySelector(".nav")

    // No sub menu, let the link go to its page
    if (!subMenu) {
      return
    }

    if (this.isMobile()) {
      e.preventDefault()
    }

    // tablet select menu and inject
    if (this.isTablet() && this.selectedItem !== ind) {
      e.preventDefault()
    }

    if (this.isTablet()) {
      this.selectedItem = ind

      if (this.selectedMenu.firstChild) {
        this.selectedMenu.removeChild(this.selectedMenu.firstChild)
      }

      let copy = subMenu.cloneNode(true)
      copy.classList.remove("hidden")
      this.selectedMenu.appendChild(copy)
    } else if (this.isMobile()) {
      this.toggleClasses(subMenu, ["hidden", "block", "md:hidden"])
    }
  },

  isMobile() {
    return window.innerWidth <= 768
  },

  isTablet() {
    return window.innerWidth > 768 && window.innerWidth < 1024
  },

  initHovers() {
    ;[...this.items].forEach((item) => {
      item.addEventListener("mouseover", () => {
        this.current(item)
      })
      item.addEventListener("mouseout", () => {
        this.current()
      })
    })
  },

  current(item = null) {
    if (item) {
      this.selected.classList.add("z-20")
      this.selected.classList.add("opacity-100")
      this.featured.classList.add("opacity-0")
      this.featured.classList.remove("opacity-100")
      const image = item.dataset.image
      this.selected.querySelector("img").setAttribute("src", `${image}?tr=w-440,h-290`)
      this.selected.querySelector("p").innerText = item.dataset.description
    } else {
      this.selected.classList.remove("z-20")
      this.selected.classList.add("opacity-0")
      this.selected.classList.remove("opacity-100")
      this.featured.classList.add("opacity-100")
    }
  },

  // Zoho's "Chat with a local!" tooltip sits over buttons near the bottom right of the window,
  // so it only shows near the top of the page. The chat bubble always shows
  toggleChatTooltip() {
    document.documentElement.classList.toggle("chat-tooltip-hidden", window.pageYOffset > 300)
  },

  toggleAnimatedHeader() {
    const scrollAmount = window.pageYOffset
    const breadcrumbs = document.querySelector(".breadcrumbs")
    const header = document.querySelector("#main-header")

    if (!header) {
      return
    }

    if (scrollAmount > (header.dataset.hero === "true" ? 70 : 5)) {
      header.classList.add("is-scrolled")
    } else {
      header.classList.remove("is-scrolled")
    }

    if (!breadcrumbs) {
      return
    }

    if (scrollAmount > 10) {
      breadcrumbs.classList.remove("opacity-1")
      breadcrumbs.classList.add("opacity-0", "hidden")
    } else {
      breadcrumbs.classList.remove("opacity-0", "hidden")
      breadcrumbs.classList.add("opacity-1")
    }
  },
  toggle() {
    if (this.active) {
      this.close()
    } else {
      this.final = true
      this.active = true
    }
  },
  close() {
    this.active = false
    setTimeout(() => {
      this.final = false
    }, 300)
  },

  toggleClasses(el, cls) {
    return cls.map((cl) => el.classList.toggle(cl))
  },

  searchFocus(targetInput) {
    // create invisible dummy input to receive the focus first
    const fakeInput = document.createElement("input")
    fakeInput.setAttribute("type", "text")
    fakeInput.style.position = "absolute"
    fakeInput.style.opacity = 0
    fakeInput.style.height = 0
    fakeInput.style.fontSize = "16px" // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.body.prepend(fakeInput)

    // focus so that subsequent async focus will work
    fakeInput.focus()

    setTimeout(() => {
      // now we can focus on the target input
      targetInput.click()
      targetInput.focus()

      // cleanup
      fakeInput.remove()
    }, 1000)
  },

  initSearch() {
    const searchTogglers = document.querySelectorAll(".search-toggler")
    const searchModal = document.querySelector(".search-form")
    const searchInput = document.querySelector("#search-input-model")

    if (!searchTogglers) {
      return
    }

    ;[...searchTogglers].forEach((searchToggler) => {
      searchToggler.addEventListener("click", () => {
        this.toggleClasses(searchModal, ["hidden"])

        if (!searchModal.classList.contains("hidden")) {
          this.searchFocus(searchInput)
          // searchInput.click()
          // searchInput.focus().setSelectionRange(0, 999)
        }
      })
    })
  },
  minChars() {
    const searchInput = document.querySelector("#search-input-model")
    const searchMinChars = document.querySelector(".search-min-chars")

    if (!searchInput) {
      return;
    }

    searchInput.addEventListener("input", function() {
      if (this.value.length < 4) {
        searchMinChars.classList.remove("invisible")
      } else {
        searchMinChars.classList.add("invisible")
      }
    })
  },
}

document.addEventListener("DOMContentLoaded", () => {
  RiverHeader.initMenu()
  RiverHeader.initSearch()
  RiverHeader.minChars()

  RiverHeader.toggleAnimatedHeader()
  RiverHeader.toggleChatTooltip()

  document.addEventListener("scroll", () => {
    RiverHeader.toggleAnimatedHeader()
    RiverHeader.toggleChatTooltip()
  })

  // this.toggleAnimatedHeader()
  //
  // document.addEventListener("scroll", () => {
  //   this.toggleAnimatedHeader()
  // })
})
